import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { map, take } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router, public afAuth: AngularFireAuth) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const uid = await this.uid();
    let isLoggedIn = !!uid;

    if (isLoggedIn) {
      let isLoggedIn = !!uid;
      return isLoggedIn;
    } else {
      this.router.navigateByUrl('/account/login');
      return false;
    }
  }

  uid() {
    return this.afAuth.authState
      .pipe(
        take(1),
        map(u => u && u.uid)
      )
      .toPromise();
  }
}
